import { render, staticRenderFns } from "./RoomJoin.vue?vue&type=template&id=16635ed0&"
import script from "./RoomJoin.vue?vue&type=script&lang=js&"
export * from "./RoomJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports